<template>
    <LayoutForm>
        <div class="form__title" v-if="id">
            <h1>Edit Event</h1>
        </div>
        <div class="form__title" v-else>
            <h1>Create Event</h1>
        </div>
        <form class="form" @submit.prevent="submit" novalidate>
            <fieldset class="form__group">
                <ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

                <div class="form__group">
                    <input id="activityName" name="activityName" class="form__control" v-model="formData.eventName"
                           placeholder="Enter a name for your Activity..." v-validate required />
                    <label for="activityName" class="form__label">Event name</label>
                    <div class="form__validation">{{ errors.first('eventName') }}</div>
                </div>

                <!-- Start Date -->
                <FormControlDatetimePicker v-model="formData.start.dateTimeString" :default-value="startDate" :min-date="null" :max-date="null"  label="Event Start Date"></FormControlDatetimePicker>
                <FormControlDatetimePicker v-model="formData.end.dateTimeString" :default-value="endDate" :min-date="null" :max-date="null" label="Event End Date"></FormControlDatetimePicker>
                <FormControlDatetimePicker v-model="formData.bilateralStart.dateTimeString" :default-value="bilateralStartDate" :min-date="null" :max-date="null" label="Bilateral Start Date"></FormControlDatetimePicker>
                <FormControlDatetimePicker v-model="formData.bilateralEnd.dateTimeString" :default-value="bilateralEndDate" :min-date="null" :max-date="null" label="Bilateral End Date"></FormControlDatetimePicker>
                <FormControlDatetimePicker v-model="formData.signupEnd.dateTimeString" :default-value="signupEnd" :min-date="null" :max-date="null" label="Signup End Date"></FormControlDatetimePicker>

                <div class="form__group">
                    <input id="location" name="location" class="form__control" v-model="formData.location"
                           placeholder="Enter a location..." v-validate />
                    <label for="website" class="form__label">Event Location</label>
                    <div class="form__validation">{{ errors.first('location') }}</div>
                </div>

                <div class="form__group">
                    <input id="bilateralMeetingRoom" name="bilateralMeetingRoom" class="form__control" v-model="formData.bilateralMeetingRoom"
                           placeholder="Enter a meeting room..." v-validate />
                    <label for="bilateralMeetingRoom" class="form__label">Bilateral Meeting Room</label>
                    <div class="form__validation">{{ errors.first('bilateralMeetingRoom') }}</div>
                </div>

                <div class="form__group">
                    <input id="popupTitle" name="popupTitle" class="form__control" v-model="formData.popupTitle"
                           placeholder="Enter a title for your popup..." v-validate />
                    <label for="popupTitle" class="form__label">Popup Title</label>
                    <div class="form__validation">{{ errors.first('popupTitle') }}</div>
                </div>

                <div class="form__group">
                    <textarea id="popupCopy" name="popupCopy" class="form__control" v-model="formData.popupCopy"
                           placeholder="Enter a description for your popup..." v-validate />
                    <label for="popupCopy" class="form__label">Popup Description</label>
                    <div class="form__validation">{{ errors.first('popupCopy') }}</div>
                </div>

                <div class="form__group form__background">
                    <img :src="formData.backgroundUrl" v-if="formData.backgroundUrl" alt="Activity background image" class="form__image">
                    <FileUpload :multiple="false" v-model="formData.background.uuid" name="background" label="Background Image">
                    </FileUpload>
                </div>

                <!-- Radio true/false button whether to show the date or not -->
                <div class="form__group">
                    <div class="toggle-group">
                        <input id="show-date" name="disabled" class="toggle" type="radio" :value="true" v-model="formData.disabled" v-validate required :checked="formData.disabled === true" />
                        <label for="show-date" class="toggle">Yes</label>
                        <input id="hide-date" name="disabled" class="toggle" type="radio" :value="false" v-model="formData.disabled" v-validate required :checked="formData.disabled === false" />
                        <label for="hide-date" class="toggle">No</label>
                    </div>
                    <label class="form__label">Hide event on the app?</label>
                    <div class="form__validation">{{ errors.first('disabled') }}</div>
                </div>

                <div class="form__group form__group--submit">
                    <button type="submit" class="btn btn--primary">Save</button>
                </div>
            </fieldset>
        </form>
    </LayoutForm>
</template>

<script>

import LayoutForm from '../../Layout/LayoutForm.vue';
import Form from '../../Form/Form';
import ValidationAlert from '../../ValidationAlert.vue';
import API from '@api';
import EventDropdown from '../../Activities/EventDropdown';
import FormControlDatetimePicker from '../../Form/Control/FormControlDatetimePicker.vue';
import FileUpload from '../../Form/FileUpload.vue';
import FormControlUser from '../../Form/Control/FormControlUser.vue';

export default {
    name: "EventForm",
    mixins: [Form],
    components: {
        FormControlUser,
        FileUpload,
        FormControlDatetimePicker,
        LayoutForm,
        ValidationAlert,
        EventDropdown
    },
    data() {
        return {
            formData: {
                eventName: '',
                location: '',
                signupEnd: {
                    dateTimeString: '',
                },
                start: {
                    dateTimeString: '',
                },
                end: {
                    dateTimeString: '',
                },
                bilateralStart: {
                    dateTimeString: '',
                },
                bilateralEnd: {
                    dateTimeString: '',
                },
                fixedStartTime: {
                    dateTimeString: '',
                },
                fixedEndTime: {
                    dateTimeString: '',
                },
                fixedBilateralStartTime: {
                    dateTimeString: '',
                },
                fixedBilateralEndTime: {
                    dateTimeString: '',
                },
                fixedSignupEndTime: {
                    dateTimeString: '',
                },
                bilateralMeetingRoom: '',
                popupTitle: '',
                popupCopy: '',
                background: {
                    url: "",
                    uuid: "",
                    filename: "",
                },
                backgroundUrl: "",
                disabled: false,
            },
        }
    },
    computed: {
        startDate() {
            if(this.id) {
                if(this.formData.fixedStartTime.dateTimeString) {
                    return new Date(this.formData.start.dateTimeString);
                }

                return null;
            } else {
                if(this.formData.start.dateTimeString) {
                    return new Date(this.formData.start.dateTimeString);
                } else {
                    return new Date();
                }
            }
        },
        endDate() {
            if(this.id) {
                if(this.formData.fixedEndTime.dateTimeString) {
                    return new Date(this.formData.end.dateTimeString);
                }

                return null;
            } else {
                if(this.formData.end.dateTimeString) {
                    return new Date(this.formData.end.dateTimeString);
                } else {
                    return new Date();
                }
            }
        },
        bilateralStartDate() {
            if(this.id) {
                if(this.formData.fixedBilateralStartTime.dateTimeString) {
                    return new Date(this.formData.bilateralStart.dateTimeString);
                }

                return null;
            } else {
                if(this.formData.bilateralStart.dateTimeString) {
                    return new Date(this.formData.bilateralStart.dateTimeString);
                } else {
                    return new Date();
                }
            }
        },
        bilateralEndDate() {
            if(this.id) {
                if(this.formData.fixedBilateralEndTime.dateTimeString) {
                    return new Date(this.formData.bilateralEnd.dateTimeString);
                }

                return null;
            } else {
                if(this.formData.bilateralEnd.dateTimeString) {
                    return new Date(this.formData.bilateralEnd.dateTimeString);
                } else {
                    return new Date();
                }
            }
        },
        signupEnd() {
            if(this.id) {
                if(this.formData.fixedSignupEndTime.dateTimeString) {
                    return new Date(this.formData.signupEnd.dateTimeString);
                }

                return null;
            } else {
                if(this.formData.signupEnd.dateTimeString) {
                    return new Date(this.formData.signupEnd.dateTimeString);
                } else {
                    return new Date();
                }
            }
        }
    },
    methods: {
        updateValue(event) {
            console.log("Got value", event);
            this.$emit('input', event);
        },
        fetchResource(id) {
            const event = API.getFullEventById(id);
            console.log(event);
            return event;
        },
        sanitizeResource(data) {
            console.log("Sanitizing data: ", data, "for ", this.id);

            if(typeof data.start === 'object') {
                data.fixedStartTime = data.start
            }

            if(typeof data.end === 'object') {
                data.fixedEndTime = data.end
            }

            if(typeof data.bilateralStart === 'object') {
                data.fixedBilateralStartTime = data.bilateralStart
            }

            if(typeof data.bilateralEnd === 'object') {
                data.fixedBilateralEndTime = data.bilateralEnd
            }

            if(typeof data.signupEnd === 'object') {
                data.fixedSignupEndTime = data.signupEnd
            }

            if(data.background) {
                this.$store.commit('selectCache/addAttachment', data.background);
            } else {
                data.background = {
                    url: "",
                    uuid: "",
                    filename: "",
                }
            }

            // remove activities
            if (data.activities) {
                delete data.activities;
            }

            // Not sure how the other forms are updating data, but this doesn't seem to do it without this line
            this.formData = data;

            return data;
        },
        eventChanged(event) {
            this.formData.event = event;
        },
        submit() {
            this.$validator.validateAll().then((result) => {
                if (!result) {
                    return;
                }

                let req = this.id
                    ? API.updateEvent(this.id, this.formData)
                    : API.createEvent(this.formData);

                req.then((response) => {
                    console.log(response);
                    this.$router.push({ name: 'view-event', params: { id: response.id } });
                })
                .catch(error => {
                    API.mapServerValidation(this.errors, this.$validator)
                })
            });
        }

    }
}
</script>

<style scoped lang="scss">
    .form__location {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        order: 2;
    }

    .form__background {
        img {
            width: 100%;
        }
    }

    .form__group {
        width: 100%;
    }

    .debug {
        max-width: 100%;
        display: block;
    }
</style>
